@if (data) {
  @if (breadcrumbsComponent) {
    <dotcom-frontend-loader [componentData]="breadcrumbsComponent" />
  }

  @if (disclaimerComponent) {
    <dotcom-frontend-loader [componentData]="disclaimerComponent" />
  }

  @for (item of data["headerBanner"]; let i = $index; track i) {
    <dotcom-frontend-loader
      [componentData]="item"
      parent="headerBanner"
      parentSpacing="zero"
    />
  }

  @for (item of data["disclaimerPopup"]; let i = $index; track i) {
    <dotcom-frontend-loader [componentData]="item" />
  }

  @if (trustPilotBarComponent) {
    <dotcom-frontend-loader [componentData]="trustPilotBarComponent" />
  }

  @if (data["pageTitle"] && data["heroContentArea"].length === 0) {
    <div lgContainer>
      <h1
        class="page-title lg-font--expressive lg-font-size-7 lg-font-size-7--medium"
      >
        {{ data["pageTitle"] }}
      </h1>
    </div>
  }

  @for (item of data["heroContentArea"]; let i = $index; track i) {
    <dotcom-frontend-loader [componentData]="item" [ngClass]="{ 'in-page-nav__hero-spacing': isInPageNavigationSet }" />
  }

  @if (
    isInPageNavigationSet && navItems && navItems.length && inPageNavComponent
  ) {
    <dotcom-frontend-loader [componentData]="inPageNavComponent" />
  }

  @if (byLineComponent) {
    <div lgContainer>
      <dotcom-frontend-loader [componentData]="byLineComponent" />
    </div>
  }

  <div lgContainer>
    @for (item of data["mainContentArea"]; let i = $index; track i) {
      <dotcom-frontend-loader [componentData]="item" contentLayout="full" />
    }

    @if (authorListBlockComponent) {
      <dotcom-frontend-loader [componentData]="authorListBlockComponent" />
    }
  </div>

  @for (item of data["lowerScreenStickyBanner"]; let i = $index; track i) {
    <dotcom-frontend-loader [componentData]="item" />
  }
}
